export const environment = {
  production: false,
  supabaseUrl: 'https://vbjeibkojnbdkoudkaqm.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZiamVpYmtvam5iZGtvdWRrYXFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU5NTA4MTYsImV4cCI6MjA2MTUyNjgxNn0.WrKyvx7r5-fiZDtKIavF_DUryAMdSgfWyBPFOS89wps',
  admins: ['ssswagatss@gmail.com'] // Add your admin emails here
};